import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

const FormUnverifiedEmail = ({email, onReload, onSendEmail}) => {
  return (
    <div className='up-ema'>
      <p className='up-ema-p'>E-mail <span className='c-1'>{email}</span> ještě nebyl ověřen. Pokud jste ho již ověřili, aktualizujte přihlášení. Pokud jste e-mail nedostali, vyčkejte, zaslání může trvat několik minut. Zkontrolujte složku nevyžádané pošty.</p>
      <button className='up-b' onClick={onReload}>
        Aktualizovat přihlášení
      </button>
      <p className='up-ema-p'>Pokud čekáte delší dobu nebo došlo k nějakému problému, pošleme vám nový ověřovací e-mail.</p>
      <button className='up-b' onClick={onSendEmail}>
        Zaslat ověřovací e-mail
      </button>
    </div>
  )
}

FormUnverifiedEmail.propTypes = {
  email: PropTypes.string,
  onReload: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired
}

export default FormUnverifiedEmail



// WEBPACK FOOTER //
// ./src/components/UserForms/FormUnverifiedEmail.js